<template>
  <service>
    <div class="service-lists">
      <div class="add-service">
        <span
          >You can add 3 speciality service – you can upload max 6 portfolio for
          each</span
        >
        <base-button-type-1
          text="ADD SERVICE"
          typeColor="blue"
          @click="$router.push({ path: 'service/add' })"
        ></base-button-type-1>
      </div>
      <div class="lists">
        <service-box
          v-for="(item, index) in lists"
          :key="index"
          :portfolioImages="item.portfolio"
          :serviceType="item.specialityTitle"
          :serviceId="item.id"
          :price="parseInt(item.price, 10)"
          :currency="item.currencyUnit"
          v-on:action="getServiceLists"
        ></service-box>
      </div>
    </div>
  </service>
</template>

<script>
import ServiceBox from '../common/ServiceBox'
import BaseButtonType1 from '../common/form-elemnets/BaseButtonType1'
import Service from './Service'
import { defaultStore } from '../../library/firebase'
import { getSpecialties } from '../../api/common_code'

export default {
  components: { Service, BaseButtonType1, ServiceBox },
  name: 'service-lists',
  data() {
    return {
      lists: []
    }
  },
  created() {
    this.getServiceLists()
    getSpecialties().then(res => {
      console.log('speciality', res)
      this.speciality = res
    })
  },
  mounted() {},
  methods: {
    getServiceLists() {
      this.lists = []
      defaultStore
        .collection('photographers_service')
        .where('uid', '==', this.$store.getters.userInfo.uid)
        .where('delete', '==', false)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.lists.push(Object.assign({ id: doc.id }, doc.data()))
            console.log('service id:', doc.id)
            console.log('service lists:', doc.data())
          })
        })
        .catch(error => {
          console.log('Error getting documents: ', error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.service-lists {
  margin-top: 40px;
  .add-service {
    width: 100%;
    height: 26px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .lists {
    margin-top: 30px;
    .service-box {
      margin-bottom: 20px;
    }
  }
}
</style>
